// extracted by mini-css-extract-plugin
module.exports = {"p16z12xq":"p16z12xq"};